<app-view-title Title="{{ 'Intellitrailer.Booking.DateAndTime.Availability' | translate : 'Availability' }}, {{booking.PickupLocation?.Name}}" [isSplitColor]="true"></app-view-title>
<view-content [centered]="true">
  <div class="row">
    <div class="col-12 col-md-6">
      <title-with-divider Title="{{ 'Intellitrailer.Booking.DateAndTime.ChoosePickupTime' | translate : 'Choose pickup time' }}"></title-with-divider>
      <mat-form-field>
        <mat-icon matPrefix (click)="setPickupDate(null, -1); $event.stopPropagation()" [ngClass]="isSameDay(this.pickupDate, this.today.toDate()) ? 'unselectable' : 'selectable'">keyboard_arrow_left</mat-icon>
        <input #pickupInput class="input-center" matInput [matDatepicker]="pickup" [(ngModel)]="pickupDate" [min]="this.today.toDate()" (dateChange)="setPickupDate($event.value)" (focus)="pickup.open()">
        <mat-datepicker-toggle matTextSuffix [for]="pickup"></mat-datepicker-toggle>
        <mat-datepicker #pickup (closed)="pickupInput.blur()"></mat-datepicker>
        <mat-icon matSuffix (click)="setPickupDate(null, 1); $event.stopPropagation()">keyboard_arrow_right</mat-icon>
      </mat-form-field>

      <timePicker #pickupTime
                  [booking]="booking"
                  [minTime]="minPickup"
                  [maxTime]="maxPickup"
                  [selectedTime]="_pickupTime"
                  [timeSlots]="pickupSlots"
                  (selectedTimeChange)="setPickupTime($event)"
                  steps="quarter"
                  [loader]="timePickerLoading"
                  (click)="isPickupTimeChangedManually = true"
                  [isClosed]="pickupClosed">
      </timePicker>
      @if (gpsBasedBookingFee && theme !== 'Tysse Utleie') {

        @if (appSettings.appType === 'app') {

          @if (!atLocation && !within30m) {
            <small>{{ 'Intellitrailer.Booking.DateAndTime.errBookingFeeMultiple' | translate : 'Please note! Reservation in advance or at another location may add a booking fee.' }}</small>
          } @else if (!atLocation && within30m) {
            <small>{{ 'Intellitrailer.Booking.DateAndTime.errBookingFeePhysical' | translate : 'Please note! Reservation at another location may add a booking fee.' }}</small>
          } @else if (atLocation && !within30m) {
            <small>{{ 'Intellitrailer.Booking.DateAndTime.errBookingFeeTime' | translate : 'Please note! Reservation in advance may add a booking fee.' }}</small>
          }

          } @else {
          @if (!within30m) {
            <small>{{ 'Intellitrailer.Booking.DateAndTime.errBookingFeeTime' | translate : 'Please note! Reservation in advance may add a booking fee.' }}</small>
          }
        }
      }
    </div>

    <div class="col-12 col-md-6">
      <title-with-divider Title="{{'Intellitrailer.Booking.DateAndTime.ChooseReturnTime' | translate : 'Choose return time'}}"></title-with-divider>
      <mat-form-field>
        <mat-icon matPrefix (click)="setReturnDate(null, -1); $event.stopPropagation()" [ngClass]="isSameDay(this.returnDate, this.today.toDate()) ? 'unselectable' : 'selectable'">keyboard_arrow_left</mat-icon>
        <input #returnInput class="input-center" matInput [matDatepicker]="return" [(ngModel)]="returnDate" [min]="minPickup.toDate()" (dateChange)="setReturnDate($event.value)" (focus)="return.open()">
        <mat-datepicker-toggle matTextSuffix [for]="return"></mat-datepicker-toggle>
        <mat-datepicker #return (closed)="returnInput.blur()"></mat-datepicker>
        <mat-icon matSuffix (click)="setReturnDate(null, 1); $event.stopPropagation()">keyboard_arrow_right</mat-icon>
      </mat-form-field>
      <timePicker #returnTime
                  [booking]="booking"
                  [minTime]="minReturn"
                  [maxTime]="maxReturn"
                  [selectedTime]="_returnTime"
                  [timeSlots]="returnSlots"
                  (selectedTimeChange)="setReturnTime($event)"
                  steps="quarter"
                  [loader]="timePickerLoading"
                  (click)="scrolltoBottom()"
                  [isClosed]="returnClosed"
                  [isOneWay]="isOneWay">
      </timePicker>
    </div>
    @if(this.Settings.clientSettings.Bookings.EnableRentFreeWhenClosed && !isSameDate())
    {
    <p>{{ 'Intellitrailer.Booking.DateAndTime.nochargedHours' | translate : 'No rent is charged outside the locations open hours' }}</p>
    }
    @if(isOneWay) {
    <p> {{'Intellitrailer.Booking.DateAndtime.OneWayDescription' | translate: 'If no times are available or some appear in red, it means the station is full'}}</p>
    }
  </div>
</view-content>

<view-actions mode="white">
  <button type="button" mat-raised-button class="mw-115" (click)="next()" [disabled]="!isValid">{{ 'Intellitrailer.Navigation.Next' | translate : 'Next' }}</button>
</view-actions>


